module.exports = {
  setCateringMenu: (state, obj) => {
    state.cateringMenu = obj
  },
  setNumberOfPeople: (state, str) => {
    state.numberOfPeople = str
  },
  setOccasion: (state, str) => {
    state.occasion = str
  },
  setUnavailableDeliveryLocation: (state, str) => {
    state.unavailableDeliveryLocation = str
  },
}
